import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { kishuMarkOptions } from '../../../constants/options.constant';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddKishu, IUpdateKishu } from '../../../models/forms/IAddUpdateKishu';
import { IFormModalProps } from '../../../models/forms/IForm';
import { IKishuVM } from '../../../models/response/IKishuResponse';
import { formatMessage } from '../../../translations/format-message';
import AddEditKishuMarkForm from '../forms/add-edit-kishu-mark-form';

const AddEditKishuMark = (props: IFormModalProps) => {
  const { kishuMarkStore } = useStore();
  const {
    AddKishuService,
    UpdateKishuService,
    GetKishuByIdService,
    resetAddUpdateKishuState,
    resetKishuDetail,
    addUpdateKishuState,
    kishuDetails,
  } = kishuMarkStore;
  const initialValues: IAddKishu | IUpdateKishu = kishuDetails;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) {
      GetKishuByIdService(Number(getTenantIdFromLocalStorage()), props.id);
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateKishuSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateKishuState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addUpdateKishuState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateKishuError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateKishuState.error) {
      toast.error(formatMessage(addUpdateKishuState.error));
      resetAddUpdateKishuState();
    }
  }, [addUpdateKishuState.error]);

  /**
   * This function adds the Kishu when "Id < 0" and updates the Existing Kishu when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = ({ Id, Kishu, KishuMark, Remarks }: IKishuVM) => {
    var addObj: IAddKishu = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      Remarks: Remarks.trim(),
      Kishu: Kishu.trim(),
      KishuMark,
    };

    var updateObj: IUpdateKishu = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      Id: props.id,
      Remarks: Remarks.trim(),
      Kishu: Kishu.trim(),
      KishuMark,
    };

    if (props.id < 0) {
      AddKishuService(addObj);
    } else {
      UpdateKishuService(updateObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getKishudetails, addUpdate Kishu observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetKishuDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <AddEditKishuMarkForm
        id={props.id}
        initialValues={initialValues}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        isLoading={addUpdateKishuState.inProgress}
        KishuTypeOptions={kishuMarkOptions}
      />
    </React.Fragment>
  );
};

export default observer(AddEditKishuMark);
